import {
    ApiHandlerNoApiParameter,
    createHandlerChainRunnerOptionalParameter,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { getSpreedlyConfig, SpreedlyConfig } from "@insite/client-framework/Services/SettingsService";

export interface LoadSpreedlyConfigParameter extends HasOnSuccess<SpreedlyConfig> {}

type HandlerType = ApiHandlerNoApiParameter<LoadSpreedlyConfigParameter, SpreedlyConfig>;

export const GetSpreedlyConfig: HandlerType = async props => {
    props.apiResult = await getSpreedlyConfig();
};

export const DispatchCompleteLoadSpreedlyConfig: HandlerType = props => {
    props.dispatch({
        type: "Context/CompleteLoadSpreedlyConfig",
        spreedlyConfig: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [GetSpreedlyConfig, DispatchCompleteLoadSpreedlyConfig, ExecuteOnSuccessCallback];

const loadSpreedlyConfig = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadSpreedlyConfig");
export default loadSpreedlyConfig;
